export function formatCompanyName(name: string | undefined | null): string {
  if (!name) return '';
  let formatted = name.trim();
  
  if (formatted.endsWith('(Persero')) {
    formatted += ') Tbk.';
  } else if (formatted.endsWith(' Tb')) {
    formatted += 'k.';
  } else if (formatted.endsWith(' T')) {
    formatted += 'bk.';
  } else if (formatted.endsWith(' Tbk')) {
    formatted += '.';
  }
  
  return formatted;
}
